import { connect } from 'react-redux';
import { getOrganizationMembersList } from '../../Projects/projectsActions';
import {
    editSubTask,
    getSubTaskDetails,
    getSubTaskEvidence,
} from '../tasksActions';
// Component
import SubTaskDetails from './SubTaskDetails';

// Store props to map with current state
const mapStateToProps = state => ({
    selectedOrganization: state.organization.selectedOrganization,
    organizationMembersList: state.project.orgMembersList,
    isLoading: state.task.isLoading,
    subTaskDetails: state.task.subTaskDetails,
});

// Actions prop to dispatch
const mapDispatchToProps = dispatch => ({
    getOrganizationMembersList: params =>
        dispatch(getOrganizationMembersList(params)),
    getSubTaskDetails: params => dispatch(getSubTaskDetails(params)),
    editSubTask: params => dispatch(editSubTask(params)),
    getSubTaskEvidence: params => dispatch(getSubTaskEvidence(params)),
});

// connect states and dispatchers with components
export default connect(mapStateToProps, mapDispatchToProps)(SubTaskDetails);
